/**
 * Opens and scrolls to the product "How to use" block when the URL
 * contains ?scroll=how-to-use. Other query params are ignored.
 * No-ops on every other product URL.
 *
 * New PDP: How to Use is a tab in [data-new-product-tabs], not an accordion.
 * Classic PDP: it is details.hdt-product-accordion__item.how-to-use.
 * Opening an hdt-accordion still goes through the summary click handler
 * in global.js. This file does not restyle either layout.
 */
(function () {
  var params = new URLSearchParams(window.location.search);
  if (params.get("scroll") !== "how-to-use") return;

  var NEW_TABS = "[data-new-product-tabs]";
  var CLASSIC = "details.hdt-product-accordion__item.how-to-use";

  function stickyOffset() {
    var header = document.querySelector("hdt-sticky-header");
    return header ? header.offsetHeight : 0;
  }

  function scrollToEl(el) {
    var top =
      el.getBoundingClientRect().top + window.pageYOffset - stickyOffset() - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  }

  function openNewTabs() {
    var root = document.querySelector(NEW_TABS);
    if (!root) return null;

    var button = root.querySelector('button[data-tab="how-to-use"]');
    if (!button) {
      var panel = root.querySelector('[tab-item][data-tab="how-to-use"]');
      if (!panel) return null;
      var panels = root.querySelectorAll("[tab-item]");
      var index = Array.prototype.indexOf.call(panels, panel);
      button = root.querySelectorAll("hdt-tab button")[index] || null;
    }
    if (!button) return null;
    if (button.getAttribute("aria-current") !== "true") button.click();
    return root;
  }

  function openClassic() {
    var details = document.querySelector(CLASSIC);
    if (!details) return null;
    if (!details.hasAttribute("open")) {
      var summary = details.querySelector("summary");
      if (summary) summary.click();
    }
    return details;
  }

  function run() {
    var target = openNewTabs() || openClassic();
    if (target) scrollToEl(target);
  }

  function start() {
    var waits = [];
    if (window.customElements) {
      if (document.querySelector(NEW_TABS)) waits.push(customElements.whenDefined("hdt-tab"));
      if (document.querySelector(CLASSIC)) waits.push(customElements.whenDefined("hdt-accordion"));
    }
    Promise.all(waits).then(function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(run);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
